export default __webpack_public_path__ + "static/media/33.54ee3727.jpg";